// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentSection_container__pxA0Q","small":"ContentSection_small__rrF_I"};